import React, { useState } from 'react';
import {
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { useNavigate } from 'react-router-dom';
import PasswordInput from './PasswordInput';
import TextInput from './TextInput';
import { useTranslation } from '../i18n';

const SignIn = ({ showNotification }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordReset, setPasswordReset] = useState(false);

  const handleSetPasswordReset = () => {
    setPasswordReset(!passwordReset);
  };

  const { t } = useTranslation();

  const onLogin = (e) => {
    e.preventDefault();
    if (passwordReset) {
      sendPasswordResetEmail(auth, email)
        .then(() => {
          // Password link sent
          showNotification(t.passwordreset);
        })
        .catch((error) => {
          const errorCode = error.code;
          showNotification(errorCode);
        });
    } else {
      signInWithEmailAndPassword(auth, email, password)
        .then(() => {
          // Signed in
          navigate('/books');
        })
        .catch((error) => {
          const errorCode = error.code;
          console.error(error);
          showNotification(
            errorCode === 'auth/invalid-credential'
              ? t.wrongcredentials
              : errorCode,
          );
        });
    }
  };

  return (
    <main>
      <form onSubmit={onLogin} className="form">
        <h1 className="h1">
          {passwordReset ? t.forgottenpassword : t.signinMessage}
        </h1>

        <TextInput
          type="email"
          labelName={t.emailLabel}
          id="floatingInput"
          onChangeFunction={(e) => setEmail(e.target.value)}
          value={email}
          required={true}
          inputmode="email"
        />

        {!passwordReset && (
          <PasswordInput
            labelName={t.passwordLabel}
            id="floatingPassword"
            onChangeFunction={(e) => setPassword(e.target.value)}
            value={password}
          />
        )}
        <div className="btn-group">
          <button className="btn btn-primary w-100" type="submit">
            {passwordReset ? t.resetpassword : t.signin}
          </button>
        </div>
        <button
          type="button"
          className="btn btn-borderless"
          onClick={handleSetPasswordReset}
        >
          {passwordReset ? t.backtosignin : t.forgotpassword}
        </button>
      </form>
    </main>
  );
};

export default SignIn;
